.step-placeholder{padding:24px;border:1px dashed #707070;border-radius:4px}.step-placeholder-title{font-size:16px;font-weight:700;margin:0 0 8px}.step-placeholder-message{color:#707070;margin:0}
/*# sourceMappingURL=step-placeholder.component-2ZVZ2CEA.css.map */
